import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { useShallow } from "zustand/react/shallow";
import { actionNameBuilder } from "../utilities/storeActionNameBuilder";
import { applyResetMiddleware } from "./middleware/resetMiddleware";
import type { ApiEndpoint } from "../types";

interface URLParamsState {
  selectedApiEndpoint: ApiEndpoint | null;

  actions: {
    setSelectedApiEndpoint: (payload: ApiEndpoint) => void;
    setCommonUrlParamsState: (payload: Partial<Omit<URLParamsState, "actions">>) => void;
    resetCommonUrlParamsState: () => void;
  };
}

const actionName = actionNameBuilder("urlParam");

export const useUrlParamStore = create<URLParamsState>()(
  devtools(
    immer(
      applyResetMiddleware((set, _, store) => ({
        selectedApiEndpoint: null,

        // Separate namespace for store actions
        actions: {
          setSelectedApiEndpoint: (payload) =>
            set(() => ({ selectedApiEndpoint: payload }), undefined, actionName("setSelectedApiEndpoint")),

          setCommonUrlParamsState: (payload) => set(() => ({ ...payload }), undefined, actionName("setCommonUrlParamsState")),

          resetCommonUrlParamsState: () => set(store.getInitialState(), undefined, actionName("resetCommonUrlParamsState"))
        }
      }))
    ),
    {
      name: "urlParamStore"
    }
  )
);

// Hook for store states
export const useUrlParamSelector = () =>
  useUrlParamStore(
    useShallow((state) => ({
      selectedApiEndpoint: state.selectedApiEndpoint
    }))
  );
